import { NavLink } from "react-router-dom";
import { useEffect } from "react";

export default function NavbarComponent() {
  useEffect(() => {
    const body = document.querySelector("body");
    const navbar = document.querySelector(".navbar");
    const menuBtn = document.querySelector(".menu-btn");
    const cancelBtn = document.querySelector(".cancel-btn");
    menuBtn.onclick = () => {
      navbar.classList.add("show");
      menuBtn.classList.add("hide");
      body.classList.add("disabled");
    };
    cancelBtn.onclick = () => {
      body.classList.remove("disabled");
      navbar.classList.remove("show");
      menuBtn.classList.remove("hide");
    };
    const links = navbar.getElementsByTagName("a");
    Array.from(links).forEach((link) => {
      link.onclick = () => {
        body.classList.remove("disabled");
        navbar.classList.remove("show");
        menuBtn.classList.remove("hide");
      };
    });
    window.onscroll = () => {
      window.scrollY > 50 ? navbar.classList.add("sticky") : navbar.classList.remove("sticky");
    };
  });

  return (
    <nav className="navbar">
      <div className="content">
        <div className="logo">
          <a href="https://discord.com/oauth2/authorize?client_id=780840339409862687&scope=bot%20applications.commands&permissions=268815424">
            Catch it!
          </a>
        </div>
        <ul className="menu-list">
          <div className="icon cancel-btn">
            <i className="fas fa-times"></i>
          </div>
          <li>
            <NavLink to="/">Home</NavLink>
          </li>
          <li>
            <NavLink to="/docs">Docs</NavLink>
          </li>
          <li>
            <NavLink to="/leaderboard">Leaderboard</NavLink>
          </li>
          <li>
            <a href="https://discord.gg/UA2HdpT">Support server</a>
          </li>
        </ul>
        <div className="icon menu-btn">
          <i className="fas fa-bars"></i>
        </div>
      </div>
    </nav>
  );
}
